import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { H3, H4, H5 } from "../../../AbstractElements";
import Slider from "react-slick";
import {
  Amount,
  CompanyName,
  EndDate,
  ExpiresToday,
  Name,
  PaidOn,
  Recentpayments,
} from "../../../Constant";
import HeaderCard from "../../Common/Component/HeaderCard";
import { Link } from "react-router-dom";
import { getDataWithToken } from "../../../Utils/restUtils";
import { getExpireToday, getRecentPayment } from "../../../CommonURL";
import { toast } from "react-toastify";

const ItemsSlider = ({ list, industryId, year }) => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };
  const ItemsSliderData = [
    {
      id: 1,
      title: "Active",
      title2: "Customers",
      price: list?.totalCustomerCount,
      color: "bg-secondary",
    },
    {
      id: 2,
      title: "Active",
      title2: "Connections",
      price: list?.totalConnectionCount,
      color: "bg-primary",
    },
  ];
  const [paymentData, setPaymentData] = useState([]);

  const [expireData, setExpireData] = useState([]);

  // useEffect(() => {
  //     ExpireData();
  // }, []);

  const ExpireData = async () => {
    const data = await getDataWithToken(getExpireToday);
    if (data.status) {
      setExpireData(data.data);
    } else {
      toast.error(data.message);
    }
  };

  useEffect(() => {
    recentPayData();
  }, [industryId, year]);

  const recentPayData = async () => {
    let url = getRecentPayment;

    const params = [];
    if (industryId) params.push(`industry_type_id=${industryId}`);
    if (year) params.push(`year=${year}`);

    if (params.length) {
      url = `${getRecentPayment}?${params.join("&")}`;
    }

    const data = await getDataWithToken(url);
    if (data?.status) {
      setPaymentData(data.data);
    } else {
      toast.error(data.message);
    }
  };

  return (
    <Fragment>
      <Col xxl="6" xl="6" lg="6" md="12" sm="12">
        {/* SLIDER ON TOP */}
        <Slider {...settings} className="items-slider m-0">
          {ItemsSliderData.map((data) => {
            return (
              <Col xl="6" lg="6" md="6" sm="6" key={data.id}>
                <Card className={`rated-product ${data.color}`}>
                  <CardBody>
                    <div className="product-detail">
                      <H4>{data.title}</H4>
                      <H4>{data.title2}</H4>
                      <H3>{data.price}</H3>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            );
          })}
        </Slider>

        {/* <Fragment>
                    <Col xl="12" md="12 box-col-30">
                        <Card className="transaction-history" style={{ height: '345px' }}>
                            <HeaderCard title={ExpiresToday} setting={true} />
                            <CardBody>
                                <div className="table-responsive sroller-style" style={{ height: '280px', overflowY: 'auto' }}>
                                    <Table className="table table-bordernone table-responsive">
                                        <thead>
                                            <tr>
                                                <th>{Name}</th>
                                                <th>{CompanyName}</th>
                                                <th>{EndDate}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {expireData.map((item, index) => {
                                                return (<tr key={index}>
                                                    <td>
                                                        <Link style={{ color: '#5F0F40', marginLeft: '13px' }} to={`${process.env.PUBLIC_URL}/report/payment-collection?user=${item.agent_id}`}>
                                                            <H5 >{item.user_name}</H5>
                                                        </Link>
                                                    </td >
                                                    <td>
                                                        <H5>{item.company}</H5>
                                                    </td>
                                                    <td>
                                                        <H5>{item.end_date}</H5>
                                                    </td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>

                    </Col>
                </Fragment> */}
        <Card className="transaction-history " style={{ height: "420px" }}>
          <HeaderCard title={Recentpayments} setting={true} />
          <CardBody>
            <div
              className="table-responsive sroller-style"
              style={{ height: "355px", overflowY: "auto" }}
            >
              <Table className="table table-bordernone table-responsive">
                <thead>
                  <tr>
                    <th>{Name}</th>
                    <th>{PaidOn}</th>
                    <th>{Amount}</th>
                    <th>Invoice Type</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentData.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Link
                          style={{ color: "#5F0F40", marginLeft: "13px" }}
                          to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${item.user_id}`}
                        >
                          <H5>{item.user_name}</H5>
                        </Link>
                      </td>
                      <td>
                        <H5>{item.paid_date}</H5>
                      </td>
                      <td>
                        <H5>${item.amount}</H5>
                      </td>
                      <td>
                        <H5>{item.invoice_type}</H5>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="text-end mt-3 pb-3">
                <Link
                  to={`${process.env.PUBLIC_URL}/billing/payment-list`}
                  style={{
                    color: "#5F0F40",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  View More →
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ItemsSlider;
